export default function Divider() {
  return <hr className="border-outline" />;
}
